import { useParams } from 'react-router-dom';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';

import './terrain_overlay_legend.scss';

interface LegendKey {
    text: string;
    color: string;
}

export function TerrainOverlayLegend() {
    const { terrainType } = useParams();

    const aspectLegend: LegendKey[] = [
        { text: 'North', color: '#ff0000' },
        { text: 'East', color: '#0000ff' },
        { text: 'South', color: '#ffff00' },
        { text: 'West', color: '#00ff00' },
    ];

    const slopeLegend: LegendKey[] = [
        { text: 'Less than 10°', color: '#00ff00' },
        { text: 'Greater than 10°', color: '#ff0000' },
    ];

    // TODO
    const elevationLegend: LegendKey[] = [];

    let legend: LegendKey[] = [];

    switch (terrainType) {
        case 'elevation':
            legend = elevationLegend;
            break;
        case 'aspect':
            legend = aspectLegend;
            break;
        case 'slope':
            legend = slopeLegend;
            break;
    }

    return (
        <ContentBox title="Terrain Overlay Legend">
            <ContentBox.Section scrollable>
                {legend.map(({ text, color }) => (
                    <div key={text} className="terrain-overlay-row">
                        <span
                            className="dot"
                            style={{
                                backgroundColor: color,
                            }}
                        />
                        {text}
                    </div>
                ))}
            </ContentBox.Section>
        </ContentBox>
    );
}
